module.exports = __webpack_public_path__ + "videos/2.9517fff.mp4";